document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.collection-scroll-container');
  if (!container) return;

  const navList = container.querySelector('.sub-nav-list');
  if (!navList) return;

  // Offset setting passed from Liquid, plus breathing room so the section
  // title isn't hidden behind the sticky bar.
  const baseOffset = parseInt(container.dataset.stickyOffset, 10) || 0;
  const scrollOffset = baseOffset + 60;

  // Gap kept between the nav's left edge and the active item.
  const NAV_EDGE_PADDING = 16;

  // True while the load hint is animating, so the IntersectionObserver
  // doesn't fight it for control of the nav's scroll position.
  let hintRunning = false;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll Hint -------------------------------------------------------
     Nudges the nav's actual scroll position, then returns it. Animating
     `transform` here would slide the whole bar sideways without revealing
     any additional items, which reads as a glitch rather than a hint. */
  function runScrollHint() {
    if (prefersReducedMotion) return;
    if (hintRunning) return;
    if (navList.scrollWidth <= navList.clientWidth + 4) return; // nothing to scroll
    if (navList.scrollLeft > 4) return; // customer already scrolled it

    hintRunning = true;
    navList.scrollTo({ left: 36, behavior: 'smooth' });

    setTimeout(() => {
      navList.scrollTo({ left: 0, behavior: 'smooth' });
      setTimeout(() => {
        hintRunning = false;
      }, 500);
    }, 500);
  }

  function cancelHint() {
    hintRunning = false;
  }

  ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((evt) => {
    navList.addEventListener(evt, cancelHint, { passive: true });
  });

  setTimeout(runScrollHint, 800);

  /* --- Smooth Scroll on Click ------------------------------------------ */
  const links = container.querySelectorAll('.js-scroll-link');

  links.forEach((link) => {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      const targetSection = targetId ? document.querySelector(targetId) : null;
      if (!targetSection) return;

      e.preventDefault();
      cancelHint();

      const topPos = targetSection.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scrollTo({ top: topPos, behavior: 'smooth' });
    });
  });

  /* --- Active State + Auto-scroll Nav ----------------------------------- */
  const sections = container.querySelectorAll('.collection-row');
  const navItems = container.querySelectorAll('.sub-nav-item');

  // Measured with rects rather than offsetLeft: the nav items' offsetParent
  // is .collection-scroll-container (it's position: relative), not the list,
  // so offsetLeft returns a value that scrolls the nav to the wrong place.
  function scrollNavToActive(activeLink) {
    if (hintRunning || !activeLink) return;

    const item = activeLink.parentElement || activeLink;
    const itemRect = item.getBoundingClientRect();
    const listRect = navList.getBoundingClientRect();
    const delta = itemRect.left - listRect.left - NAV_EDGE_PADDING;

    if (Math.abs(delta) < 2) return;

    navList.scrollTo({
      left: navList.scrollLeft + delta,
      behavior: 'smooth'
    });
  }

  const observerOptions = {
    root: null,
    rootMargin: '-20% 0px -60% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      navItems.forEach((link) => link.classList.remove('active'));

      const id = entry.target.getAttribute('id');
      const activeLink = container.querySelector(`.js-scroll-link[href="#${id}"]`);
      if (activeLink) {
        activeLink.classList.add('active');
        scrollNavToActive(activeLink);
      }
    });
  }, observerOptions);

  sections.forEach((section) => observer.observe(section));
});
